import { selectFeatureFlags } from 'core/userContext';
import { WorkflowsRootState } from '../ducks.types';

export const getIsFacebookWorkflowsFeatureFlagEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.FacebookWorkflows === true;
export const getIsQueryBuilderImprovementsEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.StudioQueryBuilder === true;
export const getIsQuietHoursEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.QuietHours === true;
export const getIsStartTileRefreshEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.StartTileRefresh === true;
export const getIsTemplateValidationEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.ContentValidationInStudio === true;
export const getIsYesNoSplitDataToggleEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.YesNoSplitDataToggle === true;
export const getIsJourneyMetricsSelectionEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneyMetricsSelection === true;
export const getIsJourneyStartTimeOptimizationEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneyStartTimeOptimization === true;
export const getIsJourneysSubscriptionPrefMultiSelectEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneysSubscriptionPrefMultiSelect === true;
export const getIsSendEmailTriggerEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.SendEmailTrigger === true;
export const getIsYesNoSplitTestEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneysYesNoTest === true;
export const getIsJourneyAIGenerationEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneyAIGeneration === true;
export const getIsJourneyStartSuppressionEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneyStartSuppression === true;
export const getIsJourneysStartTilePaginatedSelectEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneysStartTilePaginatedSelect === true;
export const getIsJourneySubscribeEntrySourceEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneySubscribeEntrySource === true;
export const getIsJourneyReviewPanelEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneysReviewPanel === true;
export const getIsJourneyNewUserEntrySourceEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneyNewUserEntrySource === true;
export const getIsSendEditorImprovementsEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneySendEditorImprovements === true;
export const getIsJourneysHoldCustomTimeEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneysHoldCustomTime === true;
export const getIsJourneysStartTileFilterSuppression = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneysStartTileFilterSuppression === true;
export const getIsJourneyLabelsEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneyLabels === true;
export const getIsJourneyFieldMappingsEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneyFieldMappings === true;
export const getIsInProgressTotalPublishedView = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.InProgressTotalPublishedView === true;
export const getIsJourneyExitEventsEnabled = (state: WorkflowsRootState) =>
  selectFeatureFlags(state)?.JourneyExitEvents === true;
export const getIsJourneyStartTileConcurrentJourneyEntranceCriteriaEnabled = (
  state: WorkflowsRootState,
) => selectFeatureFlags(state)?.JourneyStartTileConcurrentJourneyEntranceCriteria === true;
export const getIsJourneyStartTileGetEstimatedUserEnteringCountEnabled = (
  state: WorkflowsRootState,
) => selectFeatureFlags(state)?.JourneyStartTileGetEstimatedUserEnteringCount === true;
